import { ENTRYCOMPONENTSMAP } from '@core/models/component-map.model';
import { Component,
         AfterViewInit,
         OnDestroy,
         ViewChild,
         ComponentFactoryResolver,
         ViewContainerRef,
         ComponentRef} from '@angular/core';

import { AccessibilityService, ModalService } from '@core/services';
import { environment } from '@environments/environment';

@Component({
  moduleId: module.id,
  selector: 'app-modal',
  templateUrl: './modal-base.component.html',
  styleUrls: ['./modal-base.component.less']
})
export class ModalComponent implements AfterViewInit, OnDestroy {

  // viewed element children
  @ViewChild('modalbody', { read: ViewContainerRef, static: true }) ref: ViewContainerRef;
  @ViewChild('modalPopup', { static: true }) modalPopup;

  // the component body
  private compBody: any;
  private compRef: ComponentRef<any>;
  private compName: string;
  private compSelector: string;
  public customClass = '';
  // designed to be JQuery free and using bootstrap to animate the visibility
  public visible: boolean;
  public visibleAnimate: boolean;
  private defaultModal: string;
  accessibilityWidgetCssText: string;
  public showCloseButton = true;
  private hideTimeoutOuter: any;
  private hideTimeoutInner: any;
  constructor(
    private cfr: ComponentFactoryResolver,
    private modalService: ModalService,
    private accessibilityService: AccessibilityService
    ) {
      this.visible = false;
      this.visibleAnimate = false;
      this.defaultModal = 'app-default-error-modal';
  }
  ngAfterViewInit() {
    this.modalService.setModal(this);
    this.setBodyComponent();
  }

  ngOnDestroy(): void {
    this.modalService.deregister();
    clearTimeout(this.hideTimeoutOuter);
    clearTimeout(this.hideTimeoutInner);
  }

  private setBodyComponent() {
    if (this.compName && this.compName !== null && this.compName !== '') {
      this.compBody = this.compName;
    } else if (
      this.compSelector &&
      this.compSelector !== null &&
      this.compSelector !== ''
    ) {
      this.compBody = this.compSelector;
    }
    setTimeout(() => {
    this.ref.element.nativeElement.focus();
    }, 200);
  }

  private loadComponent() {
    const componentFactory = this.cfr.resolveComponentFactory(ENTRYCOMPONENTSMAP[this.compBody]);
    this.compRef = this.ref.createComponent(componentFactory);
    //app-tnc-update is blocking for every showing; anything else opts in per instance, which is what
    //lets the migration nudge block only when the decision is mandatory. Hiding the close control also
    //disables Escape, since onKeyPressed gates on it, and backdrop dismissal is already off
    const alwaysBlocking = componentFactory.selector === 'app-tnc-update';
    this.showCloseButton = !alwaysBlocking && this.compRef?.instance?.isBlockingModal !== true;
    if (this.compRef && this.compRef.instance && this.compRef.instance.hasOwnProperty('customModalDialogClass')
     && this.compRef.instance.customModalDialogClass) {
      this.customClass = this.compRef.instance.customModalDialogClass;
    }
    this.repositionCustomizationMobileWidget(this.accessibilityService.CUSTOMIZATIONMOBILEREPOSITIONWIDGETCSS, true);
    this.compRef.changeDetectorRef.detectChanges();
  }

  private repositionCustomizationMobileWidget(cssText: string, rememberExistingPosition = false) {
    if (window.location.href.indexOf('customization') > -1 && window.innerWidth <= environment.MAX_MOBILE_WIDTH) {

      const lastPosition = this.accessibilityService.setAccessibilityWidgetCSSText(cssText, rememberExistingPosition);
      if(rememberExistingPosition) {
        this.accessibilityWidgetCssText = lastPosition;
      }
    }
  }

  public setCompName(compName: string) {
    this.compName = compName;
    this.compSelector = null;
    this.setBodyComponent();
  }

  public setCompSelector(compSelector: string) {
    this.compSelector = compSelector;
    this.compName = null;
    this.setBodyComponent();
  }

  public show(autoHide: boolean = true) {
    clearTimeout(this.hideTimeoutOuter);
    clearTimeout(this.hideTimeoutInner);
    if (this.visible) {
      if (autoHide) {
        this.modalService.hideModal();
        setTimeout(() => {
          if (this.compBody !== null && typeof this.compBody !== 'undefined') {
            this.loadComponent();
          }
          this.visible = true;
          setTimeout(() => this.visibleAnimate = true, 100);
        }, 700);
      } else {
        this.ref.clear();
        this.ref.detach();
        if (this.compBody !== null && typeof this.compBody !== 'undefined') {
          this.loadComponent();
        }

        this.visible = true;
        setTimeout(() => { this.visibleAnimate = true; }, 100);
      }
    } else {
      if (this.compBody !== null && typeof this.compBody !== 'undefined') {
        this.loadComponent();
      }

      this.visible = true;
      setTimeout(() => { this.visibleAnimate = true; }, 100);
    }
  }

  public hide() {
    this.repositionCustomizationMobileWidget(
      this.accessibilityWidgetCssText ?? this.accessibilityService.DISPLAYINLINEBLOCKIMPORTANT);
    this.hideTimeoutOuter = setTimeout(() => {
      this.visibleAnimate = false;
      this.hideTimeoutInner = setTimeout(() => {
        this.visible = false;
        this.ref.clear();
        this.ref.detach();
      }, 300);
    }, 300);
  }

  public onContainerClicked(event: MouseEvent) {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      // this is currently pulled to make modals always open unless the close
      // button is hit or the internal form submits. Otherwise an off-click
      // would close the modal if the command below is enabled.
      // this.close();
    }
  }
  public onKeyPressed(event: KeyboardEvent) {
    if(event.code && event.code?.toLowerCase() == 'escape' && this.showCloseButton) {
      this.close();
    }
  }
  public close() {
    this.modalService.hideModal();
    this.repositionCustomizationMobileWidget(this.accessibilityWidgetCssText ?? this.accessibilityService.DISPLAYINLINEBLOCKIMPORTANT);      
  }
}
